import { render, staticRenderFns } from "./dataList.vue?vue&type=template&id=e54d63d4&scoped=true"
import script from "./dataList.vue?vue&type=script&lang=js"
export * from "./dataList.vue?vue&type=script&lang=js"
import style0 from "./dataList.vue?vue&type=style&index=0&id=e54d63d4&prod&lang=scss"
import style1 from "./dataList.vue?vue&type=style&index=1&id=e54d63d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54d63d4",
  null
  
)

export default component.exports